<template>
  <div>
    <Main
      ref="main"
      :columns="tableColumns"
      :data="tableData"
      :height="height"
      :loading="loading"
      @openDetail="openDetail"
    >
      <template #toolbar_form>
        <div class="d-flex align-items-center">
          <div class="side-frame">比对结果</div>
          <el-divider direction="vertical" class="mx-2"></el-divider>
          <b-button
            size="sm"
            variant="outline-success"
            class="mr-2"
            @click="compare"
          >
            开始比对
          </b-button>
          <b-button
            size="sm"
            variant="outline-success"
            @click="$refs.main.exportResult()"
          >
            导出比对结果
          </b-button>
          <div class="change-log ml-2" v-if="changeLog">{{ changeLog }}</div>
        </div>
      </template>
    </Main>

    <ResultDetail
      :visible.sync="eesultDetailOpts.visible"
      :row="eesultDetailOpts.row"
      :columns="tableColumns"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import ResultDetail from '../result-detail'
const diff = require('diff')
export default {
  components: { Main, ResultDetail },
  props: {
    height: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    origin: { type: Object, default: () => {} },
    current: { type: Object, default: () => {} },
  },
  data() {
    return {
      eesultDetailOpts: { visible: false, row: {} },
      tableData: [],
      tableColumns: [],
    }
  },
  computed: {
    changeLog() {
      if (!this.data || !this.data.length) return ''
      const changedCount = this.data.filter((item) => item.changed).length
      const removedCount = this.data.filter((item) => item.removed).length
      const addedCount = this.data.filter((item) => item.added).length
      return [
        !changedCount ? null : `【${changedCount}】条更新`,
        !removedCount ? null : `【${removedCount}】条删除`,
        !addedCount ? null : `【${addedCount}】条新增`,
      ]
        .filter(Boolean)
        .join('，')
    },
  },
  methods: {
    openDetail(row) {
      this.eesultDetailOpts = { visible: true, row }
    },
    compare() {
      if (!this.origin) {
        this.$message.error('请上传原始文件')
        return
      }
      if (!this.current) {
        this.$message.error('请上传更新文件')
        return
      }
      const { data: originData, columns: originColumns } = this.origin
      const { data: currentData, columns: currentColumns } = this.current

      if (!originColumns || !originColumns.length) return
      if (!currentColumns || !currentColumns.length) return

      if (originColumns.length !== currentColumns.length) {
        this.$message.error('Excel列不相同，无法比对。请人工修改后重试！')
        this.tableColumns = []
        this.tableData = []
        return
      }
      
      const originColumnLabels = originColumns.map(({ label }) => label)
      const currentColumnLabels = currentColumns.map(({ label }) => label)
      if (originColumnLabels.join('') !== currentColumnLabels.join('')) {
        this.$message.error('Excel列不相同，无法比对。请人工修改后重试！')
        this.tableColumns = []
        this.tableData = []
        return
      }

      this.tableColumns = originColumns
      const columnFields = originColumns.map(({ field }) => field)

      const originRows = originData.map((row) =>
        JSON.parse(JSON.stringify(row, columnFields))
      )
      const currentRows = currentData.map((row) =>
        JSON.parse(JSON.stringify(row, columnFields))
      )

      const originRowsText = originRows
        .map((row) => JSON.stringify(row).replaceAll('\\', '<--/->'))
        .join('<--<br/ >-->\n\n')
      const currentRowsText = currentRows
        .map((row) => JSON.stringify(row).replaceAll('\\', '<--/->'))
        .join('<--<br/ >-->\n\n')

      const diffLines = diff.diffLines(originRowsText, currentRowsText)
      if (!diffLines) console.error('diff is null')
      if (diffLines.length === 1) return (this.tableData = [])
      let originIndex = 0
      let currentIndex = 0
      const newRows = []
      for (let diffIndex in diffLines) {
        const diffItem = diffLines[diffIndex]

        const { added, removed, value } = diffItem
        const rows = value
          .replaceAll('<--/->', '\\')
          .split('<--<br/ >-->\n\n')
          .filter(Boolean)
          .map((vs) => vs.split('<--<br/ >-->').filter(Boolean))
          .reduce((r, n) => {
            r.push(...n)
            return r
          }, [])
          .filter((v) => v !== '\n')
          .map((row) => JSON.parse(row))
          .map((row) => ({ added, removed, ...row }))

        newRows.push(
          ...rows.map((row) => ({
            ...row,
            originIndex: added ? originIndex : originIndex++,
            currentIndex: removed ? currentIndex : currentIndex++,
          }))
        )
      }

      const removedIndexs = newRows
        .map((row, rowIndex) => (row.removed ? rowIndex : null))
        .filter((i) => i !== null)
      const changeRanges = []

      for (let removedIndex of removedIndexs) {
        const addedIndex = removedIndex + 1
        if (addedIndex >= newRows.length) continue
        const removeNextRow = newRows[addedIndex]
        if (!removeNextRow || !removeNextRow.added) continue
        changeRanges.push([removedIndex, addedIndex])
      }

      for (let changeRangeIndex in changeRanges) {
        const changeRange = changeRanges[changeRangeIndex]
        const removedIndex = changeRange[0] - changeRangeIndex
        const addedIndex = changeRange[1] - changeRangeIndex

        const originRow = newRows[removedIndex]
        const currentRow = newRows[addedIndex]
        newRows.splice(addedIndex, 1)

        const modifyCols = columnFields
          .map((field) => {
            const origin = originRow[field]
            const current = currentRow[field]
            if (origin === current) return null
            return { field, value: current }
          })
          .filter(Boolean)
        originRow.added = false
        originRow.removed = false
        originRow.changed = true

        originRow.modifyCols = Object.fromEntries(
          modifyCols.map(({ field, value }) => [field, value])
        )
      }

      const diffRows = newRows.filter(
        (diff) => diff.added || diff.removed || diff.changed
      )
      this.tableData = diffRows
    },
  },
}
</script>
<style lang="scss" scoped>
.change-log {
  font-size: 14px;
  color: #606266;
}
</style>
